import { createProviderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createProviderCallable = getCallable(createProviderDefinition);
